import { Form, Input } from "antd";
import React from "react";
interface ISecStepReg {
  index: number;
}
const SecStepReg = ({ index }: ISecStepReg) => {
  return (
    <>
      <div style={{ maxWidth: "800px", margin: "0 auto" }}>
        <Form.Item
          label="Contact Person"
          name={[index, "name"]}
          rules={[
            {
              required: true,
              min: 6,
              message: "Person name is required",
              pattern: /^[A-Za-z][ A-Za-z0-9_()&-.]*$/,
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item label="Designation" name={[index, "designation"]}>
          <Input />
        </Form.Item>

        <Form.Item
          label="Contact Number"
          name={[index, "phone"]}
          rules={[
            {
              min: 10,
              max: 10,
              message: "Please input valid mobile number",
              pattern: /^[6-9]{1}[0-9]{9}$/,
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Website"
          name={[index, "website"]}
          rules={[
            {
              type: "url",
              message: "Please enter a valid URL!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Email To"
          name={[index, "email"]}
          rules={[
            {
              type: "email",
              message: "Enter valid email address",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Email CC"
          name={[index, "CCTo"]}
          rules={[
            {
              type: "email",
              message: "Enter valid email address",
            },
          ]}
        >
          <Input />
        </Form.Item>
      </div>
    </>
  );
};

export default SecStepReg;
